import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wego-unauthorized',
  template: `
  <section class="content">
    <div class="col-md-12 text-center">
	<div class="panel panel-danger">
      <div class="panel-heading">
      Access Denied
      </div>
      <div class="panel-body"> <p>
           You don’t have an access to this page. Please try again with different user Role. Thank you!!
            <a routerLink="/">Login</a> again.
          </p>
    </div>
    </div>
    </div>
  </section>
  `,
  styles: [`.headerror {
                font-size: 150px !important;
                font-weight: normal;
                line-height: 100px;
                margin-top: 50px;
                color: #2ba2aa;
          }`]
})
export class UnAuthorizedComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/unauthorized.component.ts